import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
const PainPointsSection = lazy(() => import('./components/PainPointsSection').then(m => ({
  default: m.PainPointsSection
})));
const ProductShowcase = lazy(() => import('./components/ProductShowcase').then(m => ({
  default: m.ProductShowcase
})));
const VolumesDetail = lazy(() => import('./components/VolumesDetail').then(m => ({
  default: m.VolumesDetail
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const CountdownSection = lazy(() => import('./components/CountdownSection').then(m => ({
  default: m.CountdownSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const PurchaseNotification = lazy(() => import('./components/PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
export function App() {
  useEffect(() => {
    // Defer Meta Pixel loading to not block initial render
    const loadPixel = () => {
      if (typeof window !== 'undefined' && !(window as any).fbq) {
        const f = window as any;
        const n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [] as any[];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        (window as any).fbq('init', '1170774765082882');
        (window as any).fbq('track', 'PageView');
      }
    };
    // Use requestIdleCallback to defer pixel loading, fallback to setTimeout
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel);
    } else {
      setTimeout(loadPixel, 2000);
    }
  }, []);
  return <div className="font-body text-white bg-brand-dark overflow-x-hidden selection:bg-brand-accent/30 selection:text-brand-accent" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={<div className="min-h-[200px]" data-id="element-3" />} data-id="element-2">
        <PainPointsSection data-id="element-4" />
        <ProductShowcase data-id="element-5" />
        <VolumesDetail data-id="element-6" />
        <BonusesSection data-id="element-7" />
        <CountdownSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTASection data-id="element-13" />
        <FooterSection data-id="element-14" />
        <PurchaseNotification data-id="element-15" />
      </Suspense>
    </div>;
}